import React, { Component } from 'react';
// utils
import {Translations} from '../../../../utils';

export default class CaseOwner extends Component{
  constructor(props) {
    super(props);
    this.state = {
          title : this.translations(this.props.data.text1),
          display : 'none',
          arrowIsOpen : false
       }
    this._registerCloseEvent();
  }

  _registerCloseEvent = () => {
    document.body.onclick = function(e) {
      if(this.state.display === 'block'){
        this._openHander(e);
      }
    }.bind(this);
    this._getStatusOnchange = this._getStatusOnchange.bind(this);
  }

  handleWindowClick = () => {
      this.setState({
        display: 'none',
        arrowIsOpen: false
      });
  }

  componentWillUnmount(){
    window.removeEventListener('click', this.handleWindowClick);
  }

  componentDidMount(){
    window.addEventListener('click', this.handleWindowClick)
  }
  _clearStatus = () => {
      this.setState({
        title: this.translations(this.props.data.text1)
      });
  }

  _openHander = (e) => {
    e.stopPropagation();
     if(this.state.arrowIsOpen === true && this.state.display === 'block'){
       this.setState({
         arrowIsOpen: false,
         display: 'none'
       });
     }else{

       this.setState({
         arrowIsOpen: true,
         display: 'block'
       });
     }
  }

  _getStatusOnchange (event){
  //event.stopPropagation();
   if(event.target.getAttribute("data-name")){
     this.setState({
       title : event.target.getAttribute("data-name")
     })
    this.props.getStatusOnchange(event.target.getAttribute("data-name"));
   }
  }
  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render(){
    const display = {
        display : this.state.display
    }
    return(
      <div className="gdoc-caselist-filter-dropcontainer">
          <div
            className="gdoc-addproduct-pdiv-lan"
            onClick={this._openHander}
            tabIndex="0"
            role="list"
            data-dropdown="gdoc-addproduct-select-lng"
            aria-controls="gdoc-addproduct-select-lng"
            aria-expanded="false"
          >
            <span className="gdoc-addproduct-selected-country">
                <span className="gdoc-addproduct-plussign">{this.translations(this.props.data.text4)}</span>
                <span className="gdoc-addproduct-title">{this.state.title}</span>
            </span>
            <span className ="gdoc-addproduct-bar"> </span>
            <i className={this.state.arrowIsOpen === true ? 'icon icon-chevron-up  gdoc-addproduct-icondown' : 'icon icon-chevron-down gdoc-addproduct-icondown' }></i>
          </div>
          <ul
            id="gdoc-addproduct-select-lng"
            className="gdoc-addproduct-custom-dropdown gdocs-set-dropdown-ht"
            style={display}
          >
            {
              this.props.caseOwner.length > 0
              ? Object.keys(this.props.caseOwner).map((key)=> <li
                  key={key}
                  onClick={(event) => this._getStatusOnchange(event)}
                  data-value={this.props.caseOwner[key].name}
                  data-name={this.props.caseOwner[key].value}
                >
                  {this.props.caseOwner[key].value}
                </li>)
              : ''
            }
          </ul>
      </div>
    )
  }
}

CaseOwner.defaultProps = {
caseStatus : []
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/CaseHistory/Grid/CaseOwner.js